import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ClearIcon from 'components/icons/ClearIcon.com.svg';
import Button from 'react-bootstrap/lib/Button';
import { noop } from 'lodash';

import cn from './styles.local.less';

export default class Item extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    name: PropTypes.string,
    onClick: PropTypes.func,
    form: PropTypes.object.isRequired,
  };

  static defaultProps = {
    onClick: noop,
  };

  handleClick = (e) => {
    e.preventDefault();

    const { form, name, onClick } = this.props;

    onClick({ form, name });
  };

  render() {
    const { children, name } = this.props;

    return (
      <div className={cn.root} data-qa-selector={`filter-item-${name}`}>
        <Button bsStyle="link" className={cn.clear} onClick={this.handleClick}>
          <ClearIcon className={cn.icon} />
        </Button>
        {children}
      </div>
    );
  }
}
